import { render, staticRenderFns } from "./ClientContactParent.vue?vue&type=template&id=00532f46&"
import script from "./ClientContactParent.vue?vue&type=script&lang=js&"
export * from "./ClientContactParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports